export default __webpack_public_path__ + "static/main4-99eb397456106dd94a218328ad1c8df1.png";